import type { ActionsUnion } from '@rxsv/core';
import { U, createReducer } from '@rxsv/core';

import type {
    FilterData,
    ChartInteractionPosition,
    DataTipNavigationOption,
    NavigationCallbackItem,
    QueryChartInteractionDatapoint,
} from 'portlet/models';

export type State = object;
export const initialState: State = {};

/**
 * Following Actions are used for cross-app communication, which happens in case of `triggers`,
 * and may result in execution of particular `actions` (albeit similar in concept, do not confuse with store actions).
 */
export const Action = U.createUnion(
    U.caseOf('TA_REQUEST_NAVIGATION_OPTIONS_FOR_DATATIP')<{
        position: ChartInteractionPosition;
        data: QueryChartInteractionDatapoint | null;
        /**
         * @deprecated in favor of {@link filters}, send a single element array instead
         */
        filter: FilterData | null;
        filters: FilterData[];
    }>(),
    U.caseOf('TA_RECEIVE_NAVIGATION_OPTIONS_FOR_DATATIP')<{
        title: string;
        jumpTo: DataTipNavigationOption[];
        showBy: DataTipNavigationOption[];
    }>(),
    U.caseOf('TA_NAVIGATION_DATATIP_CLICK')<{ action: NavigationCallbackItem }>(),
);

export type Action = ActionsUnion<typeof Action>;
export const ErrorActions: Array<(typeof Action)[keyof typeof Action]> = [];

export const reducer = createReducer(initialState)<Action>({
    TA_REQUEST_NAVIGATION_OPTIONS_FOR_DATATIP: s => s,
    TA_RECEIVE_NAVIGATION_OPTIONS_FOR_DATATIP: s => s,
    TA_NAVIGATION_DATATIP_CLICK: s => s,
});
